import { capitalize, get } from 'lodash';

import { checkUserDataCache } from './login';
import { SelectionType } from '../modals/Setting/GpsSetting/GpsRouteSelectionType';
import { TimePickerType } from '../components/CustomTimePicker/CustomTimePicker';
import errorLogsSender from '../service/ErrorLogsSender';
import { getErrorMessage } from '../service/utils';
import { MessageType } from '../service/constants';
import { UNAUTHORIZED_HTTP_CODE } from '../service/Error';
import { showModal, TYPES } from './modal';
import { NotificationTypes, pushNotification } from './notifications';

const GET_ROUTE_DECLARATION = 'GET_ROUTE_DECLARATION';
const SET_CUSTOM_ROUTE_SETTINGS = 'SET_CUSTOM_ROUTE_SETTINGS';

function getRoutesDeclaration() {
    return (dispatch, getState, { apiManager }) => {
        const state = getState();
        const options = get(state, 'routesDeclaration.options');
        // После обновления приложения в сохранённом state может не быть новых feature-flag'ов
        // (например allowMessenger). Не используем кэш — подтягиваем свежую декларацию с сервера.
        const staleFeatureFlags = options && !Object.prototype.hasOwnProperty.call(options, 'allowMessenger');

        if (checkUserDataCache(state) && !staleFeatureFlags) {
            return Promise.resolve();
        }

        return apiManager
            .downloadRoutesDeclaration()
            .then((routesDeclaration) => {
                if (routesDeclaration.errors && routesDeclaration.errors.length) {
                    dispatch(
                        pushNotification({
                            variant: NotificationTypes.ERROR,
                            message: 'The fields in the declaration are filled in incorrectly',
                            details: routesDeclaration.errors
                                .reduce((accum, error) => {
                                    const errStr = `${error.id}: used ${capitalize(error.used)} but need ${capitalize(error.need)}`;
                                    accum.push(errStr);

                                    return accum;
                                }, [])
                                .join('/n'),
                        })
                    );
                    throw 'The fields in the declaration are filled in incorrectly';
                } else {
                    dispatch({ type: GET_ROUTE_DECLARATION, routesDeclaration });
                }
            })
            .catch((err) => {
                console.error(err);
                if (err.errorCode === UNAUTHORIZED_HTTP_CODE) {
                    dispatch(showModal(TYPES.RELOGIN, {}));
                    return;
                }
                const newError = new Error(getErrorMessage(err, MessageType.GET_ROUTES_DECLARATIONS), { cause: err });
                errorLogsSender.addLog(newError);
                throw newError;
            });
    };
}

function saveCustomRouteSettings({
    customRouteSettings,
    allowedDistance,
    timerStatus,
    notificationTimer,
    selectionType = SelectionType.CURRENT,
    timePickerType = TimePickerType.NATIVE,
}) {
    return (dispatch) => {
        return dispatch({
            type: SET_CUSTOM_ROUTE_SETTINGS,
            customRouteSettings,
            allowedDistance,
            selectionType,
            timePickerType,
            timerStatus,
            notificationTimer,
        });
    };
}

export { GET_ROUTE_DECLARATION, SET_CUSTOM_ROUTE_SETTINGS, getRoutesDeclaration, saveCustomRouteSettings };
